// Сторното по станции за „По станции".
//
// Ендпойнтът на справката не носи сторно, затова то се дърпа от справка
// „Сторно" (`GET /bills/cancellations`) — редовете ѝ носят `station_id`.
// Ключът на заявката е СЪЩИЯТ като в `useCancellations`, за да ползват двете
// справки един кеш вместо две еднакви заявки.
//
// Ендпойнтът е зад ДРУГО право (`view_voids`, докато справката е зад
// `view_sites_report`). Без него BE връща 403, затова заявката се пуска само
// при налично право, а екранът крие кутийката и колоната.

import { useQuery } from "@tanstack/react-query";

import {
  getCancellations,
  type CancellationsFilters,
} from "../../../../api/reportsCancellations";
import { useAppSelector } from "../../../../store/hooks";

export const useCanSeeVoids = (): boolean => {
  const permissions = useAppSelector((state) => state.auth.permissions);
  return permissions.some((permission) => permission.name === "view_voids");
};

export const useStationVoids = (
  filters: CancellationsFilters,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ["reports", "cancellations", filters],
    queryFn: () => getCancellations(filters),
    staleTime: 0,
    enabled,
  });
